import {  Label, Button,Dropdown,DropdownItem,DropdownMenu,DropdownToggle, } from "reactstrap";
import DateTimePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useState,useCallback, useEffect} from "react";
import { usePagination } from "../../hooks/usePagination";
import Table from "../table/Table";
import ApiService from "../../services/apiService";
import RightIcon from "../svg/RightIcon";
import LeftIcon from "../svg/LeftButton";
import { format } from "date-fns";
import { useMemo } from "react";
const Report = () => {

  // calling report api
   const[fromDateTime,setFromDateTime] =  useState(null);
   const[toDateTime,setToDateTime] = useState(null);
   const[chakData,setChakData] = useState<any|[]>([]);
   const[dropdownOpen,setDropdownOpen] = useState(false)
   const[secondDropdownOpen,setSecondDropdownOpen] = useState<boolean>(false)
   const[selectedApi,setSelectedApi] = useState<string|null>('chakhistory')
   const[isEnabled,setIsEnabled] = useState(false)
   const[selectedChakName,setSelectedChakName] = useState('')
   const [refreshKey, setRefreshKey] = useState(0);
   let updatedData :any =[] 

   const toggleDropdown = () => setDropdownOpen(prev => !prev);
   const toggleSecondDropdown = () =>setSecondDropdownOpen(prev => !prev);
  useEffect(()=>{
       const getChak = async() =>{
          try{
              const response = await ApiService.axiosApi(`/chack`,
                {
                  method:'GET',
                  params:{
                     pageNumber:0,
                     pageSize:0
                  }
                }
              )
              if(response.success){
                 setChakData(response.data.data)
                 
              }else{
                 console.log(response.message || response.status || "unable to get chak ")
              }
          }catch(error){
             console.log(error)
          }
       }

       getChak();
  },[])

  function formatDate(dateString: any) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  

  const {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    setFromDate,
    setToDate,
    setId,
    id,
    
} = usePagination({
    endpoint: `/${selectedApi}`,
     refreshKey,
    enabled:isEnabled
})
 
    
  

 updatedData = useMemo(() => {
  if (!data || !Array.isArray(data)) return [];
       
  return data.map((time) => {
    if (selectedApi === 'alarms/history') {
      return {
        ...time,
        alarmTimeDate: time.alarmTime ? format(new Date(time.alarmTime), 'dd-MM-yyyy HH:mm:ss') : '-',
        acknowledgeTime: time.acknowledgeTime ? format(new Date(time.acknowledgeTime), 'dd-MM-yyyy HH:mm:ss') : '-',
        offTime:time.offTime ?  format(new Date(time.offTime), 'dd-MM-yyyy HH:mm:ss') : '-',
      };
    } else {
      return {
        ...time,
        dateTime: time.dateTime ? format(new Date(time.dateTime), 'dd-MM-yyyy HH:mm:ss') : '-',
      };
    }
  });
}, [data, selectedApi]);

 

/*if(data){
   setChakHistory('')
}*/

const totalPages = Math.ceil(totalCount / pageSize);

 
const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1))
}, [setPageNumber, totalPages])



const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1))
}, [setPageNumber, totalPages])

const handleClick = () =>{
  if(fromDateTime){
    setFromDate(formatDate(fromDateTime))
  }
  if(toDateTime){
    setToDate(formatDate(toDateTime));
  }
  setIsEnabled(true); // Enable only once
  setRefreshKey(prev => prev + 1); // Force API re-fetch
  setPageNumber(1); 

 
   

  
  
 }


  return (
    <>
      <div className="report" >
        <div className="report-header d-flex justify-content-between align-items-center bg-light-primary" >

          <div className="d-flex py-2 justify-content-evenly align-items-center">
          <div className="mx-4 pb-2 input-border d-flex flex-row align-content-center items-center gap-4">

{/* First Dropdown Group */}
<div className="d-flex flex-column">
  <Label> Report Type:</Label>
  <Dropdown isOpen={secondDropdownOpen} toggle={toggleSecondDropdown} className="custom-dropdown-wrapper">
    <DropdownToggle
      className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"
      style={{
        backgroundColor: '#007bff',
        borderColor: '#007bff',
        color: '#fff',
        fontWeight: 500,
        borderRadius: '5px',
        padding: '8px 16px',
      }}
      color="primary"
    >
      {selectedApi == 'chakhistory' ? 'Chak' : "Alarm"}
    </DropdownToggle>
    <DropdownMenu
      className="custom-dropdown-menu"
      style={{
       
        overflowY: 'auto',
        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '8px 0',
      }}
    >
      <DropdownItem onClick={() => setSelectedApi('chakhistory')}>Chak</DropdownItem>
      <DropdownItem onClick={() => setSelectedApi('alarms/history')}>Alarm</DropdownItem>
    </DropdownMenu>
  </Dropdown>
</div>

{/* Second Dropdown Group */}
<div className="d-flex flex-column">
  <Label>Chak Name:</Label>
  <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="custom-dropdown-wrapper">
    <DropdownToggle
      className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"
      style={{
        backgroundColor: '#007bff',
        borderColor: '#007bff',
        color: '#fff',
        fontWeight: 500,
        borderRadius: '5px',
        padding: '8px 16px',
      }}
      color="primary"
    >
      {selectedChakName ? selectedChakName : "Select chak"}
    </DropdownToggle>
    <DropdownMenu
      className="custom-dropdown-menu"
      style={{
       
        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '8px 0',
      }}
    >
      {chakData.map((data: any) => (
        <DropdownItem onClick={() => {setId(data.id) 
            setSelectedChakName(data.chackName)}} key={data.id}>
             {data.chackName}
        </DropdownItem>
      ))}
    </DropdownMenu>
  </Dropdown>
</div>

</div>

            <div className="mx-4 input-border pb-2 d-flex flex-column ">
              <Label>From Date:</Label>
              <DateTimePicker
                className="report-input"
                dateFormat="dd/MM/yyyy HH:mm:ss"
                placeholderText="DD-MM-YYYY"
                showTimeSelect
                onChange={(date:any)=>setFromDateTime(date)}
                selected={fromDateTime}
                isClearable
                timeFormat="HH:mm:ss"
              />
            </div>
            <div className="mx-4  input-border pb-2 d-flex flex-column">
              <Label>To Date:</Label>
              <DateTimePicker
              className="report-input"
                dateFormat="dd/MM/yyyy HH:mm:ss"   
                placeholderText="DD-MM-YYYY"
                showTimeSelect
                onChange={(date:any)=>setToDateTime(date)}
                selected={toDateTime}
                isClearable
                timeFormat="HH:mm:ss"

              />
            </div>

          </div>

          <div className="d-flex py-2 buttonclass">
            <Button className="me-2 " size="md" color="success"
              onClick={handleClick}
             >
              Generate
            </Button>

            
          </div>

        

        </div>
         
        
          <Table
             isAction={false}
            data={updatedData}
            columns= {selectedApi == 'chakhistory' ? [
                {header:"Duid",accessor:"duid"},
                {header:"DateTime",accessor:"dateTime"},
                {header:"Battery",accessor:"battery"},
                {header:"Door1",accessor:"door1"},
                {header:"Door2",accessor:"door2"},
                {header:"FlowRate",accessor:"flowRate"},
                {header:"NetworkStatus",accessor:"networkStatus"},
                {header:"OnValves",accessor:"onValves"},
                {header:"Pressure",accessor:"pressure"},
                {header:"RomsAuto",accessor:"romsAuto"},
                {header:"SolarVoltage",accessor:"solarVoltage"},
                {header:"Temprature",accessor:"temprature"},
                {header:"WaterMeter",accessor:"waterMeter"},
                {header:"V1",accessor:"v1"},
                {header:"V2",accessor:"v2"},
                {header:"V3",accessor:"v3"},
                {header:"V4",accessor:"v4"},
                {header:"V5",accessor:"v5"},
                {header:"V6",accessor:"v6"},
                {header:"V7",accessor:"v7"},
                {header:"V8",accessor:"v8"},
                {header:"V9",accessor:"v9"},
                {header:"V10",accessor:"v10"},
                {header:"V11",accessor:"v11"},
                {header:"V12",accessor:"v12"},
                {header:"V13",accessor:"v13"},
                {header:"V14",accessor:"v14"},

          
            ]
            : [
              { header: "Chak Name", accessor: "chakName" },
              { header: "DistrbutaryZone", accessor: "distributaryZone" },
              { header: "SchemeVillage", accessor: "schemeVillage" },
              { header: "No. On/Of Valves", accessor: "no_Of_On_Of_Valves" },
              {header: "Alarm Time", accessor:"alarmTime"},
              {header:"Alarm", accessor:"alarm"},
              {header:"Alarm OffTime", accessor:"offTime"},
              {header:"Acknowledge By", accessor:"userName"},
              {header:"Acknowledge Remark", accessor:"acknowledgeRemark"},
              {header:"Acknowledge Time", accessor:"acknowledgeTime"}
           ]  }
            buttons={[

            ]}
          />
           <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? `icon-button` : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>
          </div>
     
     
    </>
  )
}

export default Report;